export default "__VITE_ASSET__D8oVe_9N__"